import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

export class Cuenta {
  public nivel: number;
  public tipocuenta: string;
  public codigo: number;
  public nombre: string;
  public proyeccion: string;
  public segmento: string;
}

@Injectable({
  providedIn: 'root'
})
export class CuentaContableService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }

  public postCuenta(cuentas: any, id: number): Observable <any>{
    let auxCt = [];
    for(const c of cuentas){
      const ct: Cuenta = {
        nivel: c.nivel,
        tipocuenta: c.tipoCuenta,
        codigo: c.codigo,
        nombre: c.nombre,
        proyeccion: c.proyeccion,
        segmento: c.segmento
      };
      auxCt.push(ct);
    }
    const cCuentas = {
      templateid: id,
      cuentas: auxCt
    }
    const body = JSON.stringify(cCuentas);
    const apiURL = this.apiURL + 'api/CreateCuentas';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public getCuentas(id: number): Observable <any>{
    const tmp = {
      templateid: id
    }
    const body = JSON.stringify(tmp);
    const apiURL = this.apiURL + 'api/ListCuentas';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  //unicamente se puede actualizar el nombre la proyeccion y el tipo de cuenta
  //Para el caso de actualizar se requiere el id del tipo de cuenta del catalogo
  public patchCuenta(cuenta:any, id: number): Observable<any>{
    const updateCuenta = {
      cuentaid: id,
      nivel: cuenta.nivel,
      codigo: cuenta.codigo,
      nombre: cuenta.nombre,
      proyeccion: cuenta.proyeccion,
      segmento: cuenta.segmento,
      tipoid: cuenta.tipoCuenta
    }
    const body = JSON.stringify(updateCuenta);
    const apiURL = this.apiURL + 'api/UpdateCuenta';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  
  public masivoValidaciones(templateId):Observable<any>{
    const id = {
      templateid: templateId,  
    }
    const body = JSON.stringify(id);
    const apiURL = this.apiURL + 'api/GenerarValTemplate';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public getValidaciones(templateid: number):Observable <any>{
    const id = {
      templateid: templateid,  
    }
    const body = JSON.stringify(id);
    const apiURL = this.apiURL + 'api/validaciones/list';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public postValidacion(nombre: string, expresion: string, templateid: number): Observable<any>{
     const validacion = {
      templateid: templateid,
      description: nombre,
      expresion: expresion,
      operador: '=',
      validation: true,
    }
    const body = JSON.stringify(validacion);
    const apiURL = this.apiURL + 'api/validaciones/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public patchValidacion(id:number, nombre: string, expresion: string): Observable<any>{
     const validacion = {
      validacionesid: id,
      description: nombre,
      expresion: expresion,
      validation: true,
    }
    const body = JSON.stringify(validacion);
    const apiURL = this.apiURL + 'api/validaciones/update';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public deleteValidacion(id:number): Observable<any>{
    const validacion = {
      validacionesid: id,
    }
    const body = JSON.stringify(validacion);
    const apiURL = this.apiURL + 'api/validaciones/delete';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  
}
